// Module
var code = `<div class="js-radio-container {{#spaceBetweenItems}}js-space-between-items{{/}}" {{>visualparameters}} style="{{>visibility}}">
    {{#each radioItems as radioItem:rindex}} 
    {{#if ~/isHorisontal}}
    <terceraRadioButton on-radioBtnClick="['radioBtnChange', rindex]" 
                        name="{{~/groupName ? ~/groupName + rindex : 'radioGroupEl' + rindex}}"
                        enabled="{{~/enabled}}"
                        text="{{.text}}"
                        checked="{{.checked}}"
                        additionalClass="{{.type}}" />
    {{else}}
    <terceraRadioButton on-radioBtnClick="['radioBtnChange', rindex]"
                        name="{{~/groupName ? ~/groupName + rindex : 'radioGroupEl' + rindex}}"
                        enabled="{{~/enabled}}"
                        text="{{.text}}"
                        checked="{{.checked}}"
                        additionalClass="{{.type}}" />
    {{/if}}
    {{/each}}
</div>`;
// Exports
export default code;